type SpeechFailureDetails = { errorCode: string };

// Never retain raw exception messages/stacks: they may contain paths or speech.
export function speechFailureDetails(cause: unknown): SpeechFailureDetails {
  const error = (cause && typeof cause === "object" ? cause : {}) as {
    code?: unknown;
    message?: unknown;
    name?: unknown;
  };
  const errorName = [
    "AbortError",
    "NotAllowedError",
    "SecurityError",
    "NotFoundError",
    "NotReadableError",
    "NotSupportedError",
    "EncodingError",
    "TimeoutError",
  ].find((name) => name === error.name);
  const nativeCode =
    typeof error.code === "string" &&
    /^(ANDROID|IOS|SPEECH)_[A-Z0-9_-]{1,64}$/.test(error.code)
      ? error.code
      : undefined;
  // Older Android binaries expose the recognition code only in the message.
  const legacyCode =
    typeof error.message === "string"
      ? /^(?:Offline recognition failed|Offline file recognition is unsupported): (\d+)$/.exec(
          error.message
        )?.[1]
      : undefined;
  const legacyMessages: Record<string, string> = {
    "Audio permission is required": "ANDROID_PERMISSION",
    "Offline recognition timed out": "ANDROID_TIMEOUT",
    "Offline transcription failed": "SPEECH_RECOGNITION_FAILED",
    "Provider did not use file-based segmented recognition":
      "ANDROID_NON_SEGMENTED",
    "Recognition ended before the file was consumed":
      "ANDROID_INCOMPLETE_AUDIO",
    "Speech model download could not be requested": "ANDROID_DOWNLOAD_REQUEST",
    "Speech model download failed": "SPEECH_DOWNLOAD_FAILED",
    "Unable to prepare offline recognition": "ANDROID_PREPARATION",
    "Unable to read recorded audio": "ANDROID_AUDIO_READ",
    "Unable to start offline recognition": "ANDROID_RECOGNITION_START",
  };
  const legacyReason =
    typeof error.message === "string" &&
    Object.prototype.hasOwnProperty.call(legacyMessages, error.message)
      ? legacyMessages[error.message]
      : undefined;
  return {
    errorCode:
      nativeCode ??
      (legacyCode
        ? `ANDROID_RECOGNITION_${legacyCode}`
        : legacyReason ?? errorName ?? "unknown"),
  };
}
